/**
 * 候補者向け API の JSON 応答で、エンベロープの `code` が成功を表すか判定する。
 * `code` が無い場合は従来どおり成功扱い（呼び出し側で HTTP エラーは別途扱う想定）。
 */
export function isCandidateApiCodeSuccess(response: unknown): boolean {
  const code = (response as { code?: unknown } | null)?.code;
  if (code === undefined) return true;
  return code === 1 || code === '1';
}
